import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TopBarNavigation from './navigation/TopBarNavigation';

export default class NavigationLayout extends PureComponent {
  static contextTypes = {
    contentWidth: PropTypes.number,
    ngUser: PropTypes.object,
  };

  static propTypes = {
    hideNav: PropTypes.bool,
  };

  static defaultProps = {
    hideNav: false,
  };

  render() {
    const { children, className, style, hideNav } = this.props;

    return (
      <div
        className={className}
        style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: '100%', ...style }}>
        {
          !hideNav &&
          <TopBarNavigation style={{ width: '100%' }}/>
        }
        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, height: '100%' }}>
          {children}
        </div>
      </div>
    );
  }
}